<template>
  <div class="home text-center">
    <p id="header" class="d-flex justify-center">
      <v-img
        src="../assets/elements_graphiques-04.png"
        max-width="70"
        max-height="70"
        class="mx-8"
      >
      </v-img>
      Vue Ressource
    </p>
    <v-col cols="10" class="mx-auto">
      <v-slider
        v-model="number"
        thumb-label="always"
        min="5"
        max="20"
        color="#51bdcb"
        class="pt-6"
        track-color="grey"
        append-icon="mdi-plus"
        prepend-icon="mdi-minus"
        @click:append="plusAction"
        @click:prepend="minusAction"
      ></v-slider>
    </v-col>
    <v-col class="d-flex mx-auto" cols="12">
      <v-col class="mx-auto" cols="6">
        <v-autocomplete
          :items="orderedGetAllResources"
          v-model="resources"
          item-text="name"
          name="resource"
          label="Recherche par nom"
          color="#51bdcb"
          item-color="dark"
          chips
          deletable-chips
          multiple
        >
        </v-autocomplete>
      </v-col>
      <v-col cols="6">
        <v-autocomplete
          :items="etats"
          v-model="etat"
          name="Etat"
          label="Recherche par état"
          color="#51bdcb"
          item-color="dark"
          chips
          multiple
          deletable-chips
        >
        </v-autocomplete>
      </v-col>
    </v-col>
    <div
      class="pt-7"
      v-if="
        $apollo.queries.getAllResources.loading ||
          $apollo.queries.getFollowingWeeks.loading
      "
    >
      <v-img
        src="../assets/Dual Ring-1.3s-250px.gif"
        max-height="200"
        max-width="200"
        class="mx-auto my-5"
      ></v-img>
    </div>
    <div v-else>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th></th>
              <th
                v-for="week in getFollowingWeeks"
                :key="week.id"
                class="text-center"
              >
                <v-list-item two-line class="text-center">
                  <v-list-item-content>
                    <v-list-item-title>{{ week.week }}</v-list-item-title>
                    <v-list-item-subtitle>
                      {{ week.month }} {{ week.year }} <br />
                      du {{ week.firstDate }} au {{ week.lastDate }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="resource in orderedGetAllResources"
              :key="resource.id"
              @click="openRsc(resource.id)"
            >
              <template
                v-if="
                  (resources.length == 0 ||
                    (resources.length != 0 &&
                      resources.includes(resource.name))) &&
                    resource.state != 0 &&
                    (etat.length == 0 ||
                      (etat.length != 0 &&
                        etat.includes(getEtatByNumber(resource.state))))
                "
              >
                <td id="firstCol" class="text-no-wrap">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title
                        class="text-wrap "
                        :title="resource.name"
                        >{{ resource.name }}</v-list-item-title
                      >
                      <v-list-item-subtitle>
                        {{ getEtatByNumber(resource.state) }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <ModalUpdateAss
                      :project="{}"
                      :resource="resource"
                      :assignments="resource.assignments"
                      :isFromProjectVue="false"
                    />
                  </v-list-item>
                </td>
                <td
                  v-for="(detailledResource, key) in detailledResources[
                    resource.id
                  ]"
                  :key="key + resource.id"
                  class="text-center align-start"
                >
                  <div
                    class="text-center d-flex align-start justify-space-around py-3"
                  >
                    <template>
                      <v-progress-circular
                        :rotate="-90"
                        :size="90"
                        :width="15"
                        :value="
                          (detailledResource.days / 5) * 100 +
                            (detailledResource.leaves / 5) * 100
                        "
                        :color="
                          getColor(
                            (detailledResource.days / 5) * 100 +
                              (detailledResource.leaves / 5) * 100
                          )
                        "
                      >
                        {{
                          Math.round((detailledResource.days / 5) * 100) +
                            (detailledResource.leaves / 5) * 100
                        }}%
                      </v-progress-circular>
                    </template>
                  </div>
                  <div v-if="resourcesOpened[resource.id]">
                    <template
                      v-for="(detailled,
                      index) in detailledResource.assignments"
                    >
                      <div
                        v-if="detailled === parseInt(detailled, 10)"
                        :key="index"
                      >
                        <p>
                          {{ detailledResource['projects'][index] }} :
                          {{ detailled }}j
                        </p>
                      </div>
                      <div v-else :key="index">
                        <p>
                          {{ detailledResource['projects'][index] }} :
                          {{ Number.parseFloat(detailled).toFixed(1) }}j
                        </p>
                      </div>
                    </template>

                    <div v-if="detailledResource['leaves']">
                      Congés : {{ detailledResource['leaves'] }}j
                    </div>
                  </div>
                </td>
              </template>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
  </div>
</template>

<script>
import {
  GET_FOLLOWING_WEEKS,
  GET_ALL_RESOURCES,
} from '../graphql/GraphQLQueries';
import ModalUpdateAss from '../components/ModalUpdateAss.vue';

const _ = require('lodash');

export default {
  components: {
    ModalUpdateAss,
  },

  apollo: {
    getFollowingWeeks: {
      query: GET_FOLLOWING_WEEKS,
      variables() {
        return {
          number: this.number,
        };
      },
    },
    getAllResources: {
      query: GET_ALL_RESOURCES,
      error(error) {
        if (error.graphQLErrors.length > 0) {
          if (error.graphQLErrors[0].message === 'Unauthenticated!') {
            localStorage.removeItem('apollo-token');
            this.$router.push('/');
          }
        }
        console.error(error); // eslint-disable-line no-console
      },
    },
  },

  data() {
    return {
      icon: 'mdi-account-supervisor',
      getFollowingWeeks: [],
      number: 5,
      getAllResources: [],
      resourcesOpened: [],
      resources: [],
      etat: '',
      etats: ['En cours', 'Intercontrat', "Attente d'arrivée"],
    };
  },

  computed: {
    orderedGetAllResources() {
      return _.orderBy(this.getAllResources, 'name');
    },
    detailledResources() {
      const detailled = {};
      if (this.getAllResources) {
        this.getAllResources.forEach((resource) => {
          detailled[resource.id] = {};
          if (this.getFollowingWeeks) {
            this.getFollowingWeeks.forEach((week) => {
              detailled[resource.id][week.id] = {
                days: 0,
                color: '',
                assignments: [],
                projects: [],
                leaves: 0,
              };
            });

            if (resource.leaves) {
              resource.leaves.forEach((leave) => {
                const key = `${leave.year}${leave.week.toLocaleString('en-US', {
                  minimumIntegerDigits: 2,
                  useGrouping: false,
                })}`;
                const weekElements = _.filter(this.getFollowingWeeks, {
                  year: leave.year,
                  week: leave.week,
                });

                if (weekElements && weekElements.length > 0) {
                  detailled[resource.id][key].leaves += leave.duration;
                }
              });
            }

            if (resource.assignments) {
              resource.assignments.forEach((assignment) => {
                assignment.assignmentDetail.forEach((detail) => {
                  const key = `${detail.year}${detail.week.toLocaleString(
                    'en-US',
                    {
                      minimumIntegerDigits: 2,
                      useGrouping: false,
                    }
                  )}`;
                  const weekElements = _.filter(this.getFollowingWeeks, {
                    year: detail.year,
                    week: detail.week,
                  });

                  if (weekElements && weekElements.length > 0) {
                    detailled[resource.id][key].days += detail.daysWorked;

                    detailled[resource.id][key].assignments.push(
                      detail.daysWorked
                    );
                    detailled[resource.id][key].projects.push(
                      assignment.project.name
                    );
                  }
                });
              });
            }
          }
        });
      }
      return detailled;
    },
  },

  methods: {
    openRsc(id) {
      if (this.resourcesOpened[id]) {
        this.resourcesOpened[id] = false;
      } else {
        this.resourcesOpened[id] = true;
      }
    },
    getColor(valeur) {
      let color = '#51bdcb';
      if (valeur < 100) {
        color = 'orange';
      } else if (valeur > 100) {
        color = 'red';
      }
      return color;
    },
    plusAction() {
      this.number = this.number + 1 || 5;
    },
    minusAction() {
      this.number = this.number - 1 || 20;
    },
    getEtatByNumber(stateNbr) {
      switch (stateNbr) {
        case 1:
          return 'En cours';
        case 2:
          return 'Intercontrat';
        case 3:
          return "Attente d'arrivée";
        default:
          return 'Etat inconnu !';
      }
    },
    getWeekNumber(d) {
      let dd = d;
      // Copy date so don't modify original
      dd = new Date(Date.UTC(dd.getFullYear(), dd.getMonth(), dd.getDate()));
      // Set to nearest Thursday: current date + 4 - current day number
      // Make Sunday's day number 7
      dd.setUTCDate(dd.getUTCDate() + 4 - (dd.getUTCDay() || 7));
      // Get first day of year
      const yearStart = new Date(Date.UTC(dd.getUTCFullYear(), 0, 1));
      // Calculate full weeks to nearest Thursday
      const weekNo = Math.ceil(((dd - yearStart) / 86400000 + 1) / 7);
      // Return array of year and week number
      return weekNo;
    },
  },

  mounted() {
    if (this.getAllResources) {
      this.resourcesOpened = this.getAllResources.reduce((a, b) => {
        const aa = a;
        aa[b.id] = false;
        return aa;
      }, {});
    }
  },

  updated() {
    if (this.getAllResources) {
      this.resourcesOpened = this.getAllResources.reduce((a, b) => {
        const aa = a;
        aa[b.id] = false;
        return aa;
      }, {});
    }
  },
};
</script>

<style scoped>
p#header {
  font-size: 55px;
  margin-top: 50px;
  color: gray;
}
.v-application .text-center {
  vertical-align: top;
}
#firstCol {
  width: 30%;
}
</style>
